import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress";
import "@/styles/nprogress.css";
import { getToken } from "@/utils/auth";
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false });

const whiteList = ["/login"];

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  document.title = getPageTitle(to.meta.title);

  const hasToken = getToken();

  if (whiteList.indexOf(to.path) !== -1) {
    if (hasToken) {
      next({ path: to.query.redirect || "/" });
      NProgress.done();
    } else {
      next();
    }
    return;
  }

  if (!hasToken) {
    Message({ message: "Войдите в систему", type: "warning", duration: 3e3 });
    next({ path: "/login", query: { redirect: to.fullPath } });
    NProgress.done();
    return;
  }

  const hasRoles = store.getters.roles && store.getters.roles.length > 0;
  if (!hasRoles) {
    try {
      await store.dispatch("user/getInfo");
    } catch {
      await store.dispatch("user/resetToken");
      next({ path: "/login" });
      NProgress.done();
      return;
    }
  }

  next();
});

router.afterEach(() => {
  NProgress.done();
});
